import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { Path } from 'src/app/utils/constant/paths';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class PortalService {

  constructor(
    private http: HttpService
  ) { }

  saveOrigEndpoint(data) {
    localStorage.setItem("origApiEndpoint", data);
  }

  getOrigEndpoint() {
    return localStorage.getItem("origApiEndpoint");
  }

  validateHblNumber(data, apiEndpoint) {
    return this.http.post(Path.BILLING_INVOICE.VALIDATE_HBL_NUMBER, data, apiEndpoint);
  }

  validateHblEntryNumber(data, apiEndpoint) {
    return this.http.post(Path.BILLING_INVOICE.VALIDATE_HBL_ENTRY_NUMBER, data, apiEndpoint);
  }

  // searchEntryNumber(data, apiEndpoint) {
  //   return this.http.post(Path.BILLING_INVOICE.SEARCH_ENTRY_NUMBER, data, apiEndpoint);
  // }

  searchWarehouse(params, apiEndpoint) {
    const isParallelWebtool = (_.includes(window.location.hostname,'parallel') ? true : false);
    let path = Path.BILLING_INVOICE.SEARCH_WAREHOUSE;

    if (isParallelWebtool) {
      path = Path.BILLING_INVOICE.SEARCH_WAREHOUSE_PARALLEL;
    }

    return this.http.get(path, params, apiEndpoint);
  }

  generateInvoice(data, apiEndpoint) {
    return this.http.post(Path.BILLING_INVOICE.DOWNLOAD_INVOICES, data, apiEndpoint);
  }
}
